import { render, staticRenderFns } from "./NationSearchPopComp.vue?vue&type=template&id=bb60ad22&scoped=true"
import script from "./NationSearchPopComp.vue?vue&type=script&lang=js"
export * from "./NationSearchPopComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb60ad22",
  null
  
)

export default component.exports